import BaseHttpService from "JS/services/BaseHttpService";
import { IApplyGiftCardRequest, IWorkOrderSessionResource } from "../types/session";
import { IBaseHttpService } from "JS/types/Http";

export interface IAutomotiveSchedulerApplyGiftCardResponse {
	errorMessage: string;
	session: IWorkOrderSessionResource;
}

export interface IAutomotiveSchedulerPaymentService {
	applyGiftCard(request: IApplyGiftCardRequest): Promise<IAutomotiveSchedulerApplyGiftCardResponse>;
	removePaymentMethod(paymentMethodID: number): Promise<IWorkOrderSessionResource>;
}

const base = "/automotive-scheduler/payment";

export class AutomotiveSchedulerPaymentService implements IAutomotiveSchedulerPaymentService {
	constructor(private _httpService: IBaseHttpService = new BaseHttpService) {}

	applyGiftCard(request: IApplyGiftCardRequest): Promise<IAutomotiveSchedulerApplyGiftCardResponse> {
		return this._httpService.post(`${base}/apply-gift-card`, request);
	}

	removePaymentMethod(paymentMethodID: number): Promise<IWorkOrderSessionResource> {
		return this._httpService.post(`${base}/remove-payment-method`, { paymentMethodID });
	}
}
